import * as React from 'react';
import { ConfirmationBox } from './ConfirmationsBoxWrapper/ConfirmationBox';
import { observer } from 'src/utils/mobx-react';
import { useCommon } from 'src/domains/common/Common';
import { AppPlayersState } from 'src/domains/players/state/AppPlayers.state';

export const ConfirmationsBoxWrapper = observer('ConfirmationsBoxWrapper', () => {
    const common = useCommon();
    const appPlayersState = AppPlayersState.get(common);
    const {
        confirmationBox: { confirmationForView },
    } = appPlayersState;

    if (confirmationForView === null) {
        return null;
    }

    const { title, message, onConfirm, onReject } = confirmationForView;

    return (
        <ConfirmationBox
            message={message}
            title={title}
            onConfirm={onConfirm}
            onReject={onReject}
        />
    );
});
